import {TaxType} from "./taxType";
/**
 * Created by alex.y on 8/8/2017.
 */
export class Tax {
    public Type: TaxType;
    public Percentage: number = 0;
    public Value: number = 0;
}


// WEBPACK FOOTER //
// ./app/objects/orders/tax.ts